import { useContext, useState } from 'react'

import { useSelector } from 'react-redux'
import Cookie from 'js-cookie'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import {
  DEFAULT_DATA, InternshipRequestPortalFormContext, Modes
} from '../../Providers/Forms/InternshipRequestPortal/InternshipRequestPortalFormProvider'
import { RequestPortalContext } from '../../Providers/RequestPortalProvider'
import PortalRequesterForm from './PortalRequesterForm'
import { isValid } from '../../utils/validators'
import { StudentValidators } from '../../utils/entities/student'
import { Cookies } from '../../utils/Cookie'
import { StorageKeys } from '../../Providers/AuthProvider'
import { Properties } from '../../utils/entities'
import { onWarning } from '../../utils/apiHelper'
import { checkRequesterEmail, RequesterActions } from '../../utils/api/schoolPortalRequest'
import { PortalCoordinator } from '../../utils/entities/schoolPortalRequest'
import ActivationPendingModal from './ActivationPendingModal'
import ConfirmSchoolModal from './ConfirmSchoolModal'

const SchoolRequesterForm = ({ addressee = {}, institutionName = '', portalAccessKey, visible = false, onAllowed, onHasAccount }) => {
  const { setFormHandler } = useContext(InternshipRequestPortalFormContext)
  const { setStudentEmail } = useContext(RequestPortalContext)

  const t = useSelector(selectTranslate)

  const [email, setEmail] = useState('')
  const [errorFields, setErrorFields] = useState([])
  const [action, setAction] = useState('')
  const [loading, setLoading] = useState(false)

  const enterWizard = email => {
    setFormHandler({
      data: { ...DEFAULT_DATA[Modes.SCHOOL], [Properties.COORDINATOR]: new PortalCoordinator({ email }) },
      mode: Modes.SCHOOL
    })

    onAllowed()
  }

  const redirectToLogin = email => {
    setStudentEmail(email)

    Object.values(Cookies).forEach(value => Cookie.remove(value))
    window.localStorage.removeItem(StorageKeys.ACCOUNT_ID)

    onHasAccount()
  }

  const handleSubmit = event => {
    event.preventDefault()

    const trimmedEmail = email.trim()
    const errors = isValid({ email: trimmedEmail }, [StudentValidators.email]).keys

    setErrorFields(errors)

    if (errors.length !== 0) {
      return
    }

    setLoading(true)

    checkRequesterEmail(trimmedEmail, portalAccessKey, addressee).then(({ data }) => {
      const requesterAction = data?.action ?? data

      if (requesterAction === RequesterActions.REDIRECT_TO_LOGIN) {
        redirectToLogin(trimmedEmail)
      } else if (requesterAction === RequesterActions.ALLOW) {
        enterWizard(trimmedEmail)
      } else {
        setAction(requesterAction)
      }
    }).catch(() => {
      onWarning(t('school_portal.requester.check_unavailable'))
      enterWizard(trimmedEmail)
    }).finally(() => setLoading(false))
  }

  if (!visible) {
    return null
  }

  return (
    <>
      <ActivationPendingModal
        visible={action === RequesterActions.ACTIVATION_PENDING}
        onCancel={() => setAction('')}
        onConfirm={() => redirectToLogin(email.trim())}
      />

      <ConfirmSchoolModal
        visible={action === RequesterActions.CONFIRM_SCHOOL}
        onLogin={() => redirectToLogin(email.trim())}
        onNewSchool={() => {
          setAction('')
          enterWizard(email.trim())
        }}
      />

      <PortalRequesterForm
        email={email}
        emailLabel='school_portal.requester.email'
        hasEmailError={errorFields.includes(Properties.EMAIL)}
        helpLabel='school_portal.requester.email_help'
        institutionName={institutionName}
        loading={loading}
        title='school_portal.title'
        onEmailChange={event => setEmail(event.target.value)}
        onHasAccount={() => redirectToLogin(email.trim())}
        onSubmit={handleSubmit}
      />
    </>
  )
}

export default SchoolRequesterForm
